import { c as _c } from "react/compiler-runtime";
import { LOCALE } from '@/constants/config';
import useIsDev from '@/contexts/appContext/hooks/useIsDev';
import useQuery from '@/hooks/useQuery';
import { BookableQuery } from '@/queries/bookables.gql';
import { FPagePreciseNameEnum } from '@/types/pages';
import sendGTMPageView from '@/utils/gtm/sendGTMPageView';
import { Loader } from '@winelidays/wld-tsx-2/elements';
import { Suspense, useEffect } from 'react';
import { useLocation, useParams } from 'react-router-dom';
import ExperiencePageContent from './ExperiencePageContent';
const ExperiencePage = () => {
    const $ = _c(18);
    const isDev = useIsDev();
    const { experienceId } = useParams();
    const location = useLocation();
    let t0;
    let t1;
    if ($[0] !== experienceId || $[1] !== location.pathname) {
        t0 = () => {
            sendGTMPageView({ custom_page_path: location.pathname, page_name: FPagePreciseNameEnum.experiencePage, experience_id: experienceId ?? null });
        };
        t1 = [experienceId, location.pathname];
        $[0] = experienceId;
        $[1] = location.pathname;
        $[2] = t0;
        $[3] = t1;
    }
    else {
        t0 = $[2];
        t1 = $[3];
    }
    useEffect(t0, t1);
    const id = parseInt(experienceId ?? "null");
    const t2 = isNaN(id);
    let t3;
    if ($[4] !== id) {
        t3 = { cheap: false, id, locale: LOCALE };
        $[4] = id;
        $[5] = t3;
    }
    else {
        t3 = $[5];
    }
    let t4;
    if ($[6] !== t2 || $[7] !== t3) {
        t4 = { fetchPolicy: "cache-and-network", skip: t2, variables: t3 };
        $[6] = t2;
        $[7] = t3;
        $[8] = t4;
    }
    else {
        t4 = $[8];
    }
    const { data, error: queryError } = useQuery(BookableQuery, t4);
    const error = isNaN(id) ? "invalid experience id" : queryError;
    let t5;
    if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
        t5 = <Loader />;
        $[9] = t5;
    }
    else {
        t5 = $[9];
    }
    let t6;
    if ($[10] !== error || $[11] !== isDev) {
        t6 = isDev ? <div className="max-w-full">{JSON.stringify(error)}</div> : null;
        $[10] = error;
        $[11] = isDev;
        $[12] = t6;
    }
    else {
        t6 = $[12];
    }
    let t7;
    if ($[13] !== data) {
        t7 = data ? <ExperiencePageContent experience={data.bookable}/> : null;
        $[13] = data;
        $[14] = t7;
    }
    else {
        t7 = $[14];
    }
    let t8;
    if ($[15] !== t6 || $[16] !== t7) {
        t8 = <div className="relative w-full flex flex-col min-h-100"><Suspense fallback={t5}>{t6}{t7}
      </Suspense>
    </div>;
        $[15] = t6;
        $[16] = t7;
        $[17] = t8;
    }
    else {
        t8 = $[17];
    }
    return t8;
};
export default ExperiencePage;
